import {
  IOutcomeServerGame,
  IOutcomeServerResponse,
  IOutcomeSessionResponse,
} from '../../types/interfaces/Slots/Outcome';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';

import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { getSlotImage, getTab } from './utils';
import { CasinoType } from 'modules/Casino/types/configuration';

const hiddenProviders = ['redrake', 'hacksaw'];

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IOutcomeServerResponse>): ISlotViewItem[] => {
    const result = data?.Games?.filter((item: IOutcomeServerGame) => !hiddenProviders?.includes(item?.SectionId)).map(
      (item: IOutcomeServerGame) => ({
        id: item.Id,
        gameId: item.Id,
        description: item.Description,
        type: CasinoType.slots,
        format: item.Format,
        gameName: item.Name,
        tab: getTab(item.Id),
        provider: item.Id === 'sun_of_egypt_3_bng_html' ? 'booongo' : item.SectionId,
        imageUrl: getSlotImage(item.Id),
        routeProvider: 'outcome',
      }),
    );

    return result;
  };

  convertGameUrl = ({ data }: IOutcomeSessionResponse) => data.SessionUrl;
}

export default Converter;
